import type { ReactNode, RefObject } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";

type ChatMessageThreadProps = {
  children: ReactNode;
  compact?: boolean;
  messageCount?: number;
  scrollAnchorRef?: RefObject<HTMLDivElement | null>;
  className?: string;
};

export function ChatMessageThread({
  children,
  compact = false,
  messageCount,
  scrollAnchorRef,
  className,
}: ChatMessageThreadProps) {
  const label =
    messageCount != null ? `Chat messages - ${messageCount} messages` : "Chat messages";

  if (compact) {
    return (
      <div
        className={cn("flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto p-4 pr-3", className)}
        role="log"
        aria-live="polite"
        aria-label={label}
      >
        {children}
        {scrollAnchorRef ? <div ref={scrollAnchorRef} /> : null}
      </div>
    );
  }

  return (
    <ScrollArea aria-label={label} role="log" aria-live="polite" className={cn("min-h-0 flex-1", className)}>
      <div className="mx-auto grid gap-2 lg:gap-4 p-1 md:p-2 lg:p-4">
        {children}
        {scrollAnchorRef ? <div ref={scrollAnchorRef} /> : null}
      </div>
    </ScrollArea>
  );
}
